import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "icon"];
  static values = { open: { type: Boolean, default: false } };

  connect() {
    this.updateDisplay();
  }

  toggle(event) {
    // Don't toggle when clicking interactive elements inside the header
    if (event.target.closest("[data-no-collapse]")) return;

    this.openValue = !this.openValue;
    this.updateDisplay();
  }

  updateDisplay() {
    this.rowTargets.forEach((row) => {
      row.classList.toggle("hidden", !this.openValue);
    });

    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.openValue ? "rotate(90deg)" : "rotate(0deg)";
    }
  }
}
